
 <ul class="layout-menu margin" >
    <li class="mobileMenu mt-4" app-menuitem *ngFor="let item of items; let i = index;" [item]="item" [index]="i" [root]="true"></li>

    <div *ngFor="let item of activeMenuItem?.items; let i = index;" class="desktopMenu">
        <li  class="selectButton " app-menuitem [item]="item"  [index]="i" [root]="false"></li>
        <li   class="selectButton " *ngIf="item.label === ('MENU.CLIENT_LIST' | translate)">
            <menu-group-list  *ngIf="companyGroups && companyGroups.length > 0" [companyGroups]="companyGroups" (selectedGroupChange)="selectGroup($event)"></menu-group-list>
        </li>
    </div>

</ul>
